import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';

import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { AnalyticsService } from 'src/app/services/analytics.service';


@Component({
  selector: 'app-modal-complete-information',
  templateUrl: './modal-complete-information.page.html',
  styleUrls: ['./modal-complete-information.page.scss'],
})
export class ModalCompleteInformationPage implements OnInit {

  questions
  additional_questions
  constructor(
    public authService: AuthService,
    public navParams: NavParams,
    public toolsService: ToolsService,
    public modalController: ModalController,
    private analyticsService: AnalyticsService
  ) { 
    this.analyticsService.AnalyticsServiceModalView('complete-information');
  }

  ngOnInit() {
    let questions = this.navParams.data.questions;
    this.selectQuestions(questions)
    this.additional_questions = this.navParams.data.additional_questions
    this.questions = this.questions.concat(this.additional_questions)
  }


  selectQuestions(questions) {
     this.questions = questions.map(question => {
       if (question.format === 'select' && question.name === 'gender') {
         question.options.push({ name: 'Otro', value: 'OTHER' });
       }
       if (question.format === 'select' && question.name === 'document_type') {
           question.options.push({ name: 'Cédula de Extranjería', value: 'CE' });
       }
       return question;
     });
  }

  //Function to update profile data
  async editUserData() {
    if (this.toolsService.validateQuestions(this.questions)) {
      await this.toolsService.showLoader();
      try {
        if (this.questions.length > 0) await this.authService.updatePlayerData(this.questions);
        if (this.additional_questions.length > 0) await this.authService.updateAdditionalPlayerData(this.additional_questions);
        this.toolsService.showSuccessToast('Usuario actualizado');
        this.modalController.dismiss()
      } catch (error) {
        console.error('[PROFILE-PAGE] updateProfileData()', error);
        this.toolsService.showErrorToast();
      }
      await this.toolsService.dismissLoader();
    } else {
      this.toolsService.showErrorToast("Debes llenar todos los datos para continuar")
    }
  }

  async cancelAskInfo() {
    await this.authService.cancelAskInformation()
    this.modalController.dismiss();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
